module.exports = __webpack_public_path__ + "img/nano-crawler-logo.36cbc364.png";